import { gameProfileApi, usersApi } from '@libs/shared/src/common/api';
import { IGameProfile } from '@libs/shared/src/common/domains/game/game-profile';
import { seasonsApi } from '@libs/shared/src/common/domains/game/SeasonsApi/SeasonsApi';

import { SeasonEnum } from '../../utils/enums/season';

export class GameScene extends Phaser.Scene {
  user: IGameProfile;
  apiIsCalled: boolean;

  constructor(scene: string) {
    super(scene);
  }

  async getUser() {
    try {
      console.log('Fetching user information...');
      const [authUser, activeSeasons] = await Promise.all([
        usersApi.getMe(),
        seasonsApi.getActiveSeasons(),
      ]);

      const user = await gameProfileApi.getUserProfile(authUser.id);

      if (!user) return;

      const avatars =
        activeSeasons.seasonName === SeasonEnum.COMPANY_BIRTHDAY
          ? await usersApi.getPaginatedList({})
          : { payload: [] };

      const avatarIds = avatars?.payload
        .filter((user) => user.avatar !== null && user.avatar.id)
        .map((user) => user.id);

      this.user = {
        ...user,
        seasons: activeSeasons,
        avatars: avatarIds,
      };
    } catch (error) {
      console.error('Error fetching user information:', error);
    }
  }
}
